import React from 'react'
import { cn } from '../../../utils';

export default function RedDot({className}) {
  return (
    <div
      className={cn(
        'absolute right-[-1px] top-[-1px] h-[12px] w-[12px] rounded-full border-[1px] border-white bg-indicator-red',
        className
      )}
    ></div>
  );
}
